import React from 'react';
import { Card, Row, Col, Space, Collapse, Tag } from 'antd';

function QandA(props: any) {

    return <Card title="常见问题" style={{ width: '100%' }}>
        <Space direction="vertical" size='middle' style={{ width: '100%' }}>
            <div>
                <h6>1.类似商品运费为什么不一样</h6>
                <p>- 不同商家，不同类目，不同品类都会导致价格不一样，发现运费不一样或者过高时，请排查商品类目和重量是否一致<br/>
                常见情况：仓库重量需要等到商品购买后仓库称到足够多以后才会有，所以用户购买后相同商品重量也很容易发生变化导致运费上涨</p>
            </div>
            <div>
                <h6>2.为什么税收过高</h6>
                <p>- 便捷直邮税收洋酒c41：28.9%、啤酒c42：9.1%、葡萄酒c43：17.9%、高价美妆（超过¥10/ml）：23%、珠宝"f3", "f4", "f5", "f9"：17.9%、其他：9.1%<br/>
                请排查商品类目是否正常</p>
            </div>
            <div>
                <h6>3.为什么服务费过高</h6>
                <p>- 服务费由多种服务费组成，请从上方服务费明细查看各个服务费款项</p>
            </div>
            <div>
                <h6>4.为什么提交订单时提示“没有可用运送方式”</h6>
                <p>- 商家商品在进入别样的商品库以后，可能出现没法运输的情况。如果没有任何一种运送方式可以用，就会提示“无可用运送方式”，出现时，请查看运送方式限制，查看各个类型不可用的原因。另外，别样的物流渠道随时处于动态调整，所以商品可能会突然可以购买，突然不能购买。</p>
            </div>
            <div>
                <h6>5.为什么会提示“商家暂不支持DHL快递”、“商家暂不支持便捷直邮”、“商家暂不支持普通平邮”</h6>
                <p>- 转运仓库能支持的渠道有区别，根据商家支持的转运仓库情况，支持的运送方式也会区别，一些地区不会普通平邮、便捷直邮、DHL快递都支持，这类提示说明这个商家无法使用该运送方式</p>
            </div>
            <div>
                <h6>6.为什么会提示“包含普通平邮不支持的商品”</h6>
                <p>-普通平邮里包含多个渠道，请通过查看上方“普通平邮渠道限制”查看各渠道限制原因</p>
            </div>
        </Space>
    </Card>
}

export default QandA;